<template lang="pug">
section.section(
    :class="classes"
    @click="editSection"
)
    include base.pug
    .content-wrappers.tag-selector(v-if="!isEmpty || $slots.default")
        slot
        //- .edit(v-if="edit")
        //- .preview(v-else)
        .preview(v-if="!isEmpty && tagOptions.length")
            // wrap el-tag to bypass transition
            .tags
                el-tag(
                    v-for="tag in getTags(section)"
                    type="info"
                    :key="tag.id"
                    effect="dark"
                ) {{ tag.name }}

        .error(v-if="!tagOptions.length")
            el-alert(type="warning" effect="dark" :title="$t('There are no file tags for this CMS!')")

    el-drawer.full-height-drawer.visible-overflow(
        v-if="editable"
        :title="$t('Edit {section}', { section: section.name })"
        :visible.sync="scopedUI.form"
        :close-on-press-escape="true"
        :wrapper-closable="false"
        :append-to-body="true"
        size="920px"
        :modal="true"
        @closed="resetDrawer"
    )
        .drawer-body(v-loading="drawer.loading")
            el-tabs(
                v-if="!drawer.loading"
                v-model="drawer.tab"
                tab-position="top"
            )
                el-tab-pane(name="content" :label="$t('Content')")
                    .tab-content
                        .content-wrapper
                            el-form-item(:label="$t('Tags')")
                                el-select.is-full-width.dark(
                                    placeholder=""
                                    v-model="tags"
                                    valueKey="id"
                                    effect="dark"
                                    multiple
                                )
                                    el-option(
                                        v-for="tag in tagOptions"
                                        :key="tag.id" :label="tag.name" :value="tag"
                                        :disabled="tag.disabled"
                                    )
                el-tab-pane(name="settings" :label="$t('Settings')")
                    .block-settings
                        .settings-wrap
                            include settings.pug
        .drawer-footer
            include section-drawer-footer.pug

</template>

<i18n>
{
    "en": {
        "Edit {section}": "Edit {section}"
    },
    "de": {
        "Edit {section}": "{section} bearbeiten",
        "Content": "Inhalt",
        "Settings": "Einstellungen",
        "Tag": "Tag",
        "Tags": "Tags",
        "There are no file tags for this CMS!": "Für dieses CMS gibt es keine Datei-Tags!",
        "from": "ab",
        "to": "bis",
        "Margin top": "Abstand oben",
        "Margin bottom": "Abstand unten",
        "none": "Ohne",
        "small": "Klein",
        "medium": "Mittel",
        "large": "Groß",
        "default": "Standard",
        "custom": "Benutzerdefiniert",
        "Everybody": "Jedem",
        "Members": "Mitgliedern",
        "Guests": "Gästen",
        "Any": "Alle",
        "Tags": "Tags",
        "Select tags": "Tags auswählen",
        "Accessible by": "Zugänglich von",
        "e.g. 40px, 10%, 2em, ...": "z.B. 40px, 10%, 2em, ...",
        "desktop": "Desktop",
        "tablet": "Tablet",
        "mobile": "Telefon",
        "Visible on":"Anzeigen auf",
        "Element is displayed on":"Inhaltselement <br> wird dargestellt auf"
    }
}
</i18n>

<script>

import _ from 'lodash'

import store from '@/store'
import Section from './Section'

export default {
    name: 'Files',
    extends: Section,
    computed: {
        editable() {
            return true;
        },
        isEmpty() {
            // let empty = !this.$slots.default
            let empty = true

            // if (empty && this.section.tags && this.section.tags.length) empty = false
            // if (empty && this.section.tags && this.section.tags.length) empty = false

            // if (empty && this.section.informations && this.section.informations.length) empty = false
            if (empty && this.section.fileTags && this.section.fileTags.length) empty = false
            // if (empty && this.section.shopTags && this.section.shopTags.length) empty = false
            // if (empty && this.section.products && this.section.products.length) empty = false

            // const contents = _.get(this.section, 'contents') || []
            // contents.forEach(content => {
            //     if (! empty) return
            //     if (content.addresses && content.addresses.length) empty = false
            //     if (content.images && content.images.length) empty = false
            //     if (content.media && content.media.length) empty = false
            //     if (content.title || content.sub_title || content.text) empty = false
            // })

            return empty
        },
        tags: {
            get() {
                const section = this.drawer.section || this.section
                return this.getTags(section)
            },
            set(tags) {
                const section = this.drawer.section || this.section
                this.$set(section, 'fileTags', tags);
            }
        },
        tagOptions() {
            // const options = store.getters[`${this.module}/options`]
            return _.get(this.options, 'fileTag.items') || []
        },
    },
    methods: {
        getTags(section) {
            return _.get(section, 'fileTags') || []
        },
    }
}
</script>

<style lang="sass" scoped>
.preview
    .tags
        margin-bottom: 0
</style>
